import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/handshake': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M519.2 127.9L471.6 80.3A56.3-56.3 0 0 1 432 64H205.2C190.4 64 176.1 69.9 165.6 80.3L118 127.9H0V383.6H64C81.6 383.6 95.8 369.4 95.9 351.9H105L189.6 428.3C220.5 453.4 263.4 454 295.2 432.1 307.7 442.9 321.2 448 336.3 448 354.5 448 371.6 440.6 385.1 424 407.2 432.7 433.3 426.6 449.1 407.2L475.3 374.9C480.9 368 484.4 360.1 486.2 351.9H544.1C544.2 369.4 558.5 383.6 576 383.6H640V127.9H519.2zM48 351.6C39.2 351.6 32 344.4 32 335.6S39.2 319.6 48 319.6 64 326.8 64 335.6C64 344.5 56.8 351.6 48 351.6zM438 344.7L411.9 376.9C409.1 380.3 404.1 380.9 400.6 378.1L376.7 358.7 346.7 395.2C340.7 402.5 331.7 400 328.7 397.6L291.9 366.1 276.3 385.3C262.4 402.4 237.1 405 221 391.9L123.7 303.9H96V175.8H137.9L199.6 114.2C201.6 113.4 203.3 112.7 205.3 111.9H262L223.3 147.4C193.9 174.3 192.2 219.7 218.9 248.7 233.7 264.9 280.1 289.9 320.4 253.1L328.6 245.6 436.8 333.4C440.2 336.2 440.7 341.3 438 344.7zM544 303.9H474.8C472.5 301.1 469.9 298.5 467.1 296.2L364.4 212.8 376.9 201.4C383.4 195.4 383.9 185.3 377.9 178.8L367 167.1C361 160.6 350.9 160.2 344.4 166.1L289.2 216.7C279.7 225.4 263.5 226.1 254.6 216.7 245.3 206.8 246.1 191.6 255.8 182.8L321.4 122.7C328.8 115.9 338.4 112.2 348.4 112.2L432.1 112C434.2 112 436.2 112.8 437.6 114.3L499.3 175.9H544V303.9zM592 351.6C583.2 351.6 576 344.4 576 335.6S583.2 319.6 592 319.6 608 326.8 608 335.6C608 344.5 600.8 351.6 592 351.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/handshake.js
// module id = PnfK
// module chunks = 144